module.exports = __webpack_public_path__ + "img/spyder-token-disabled.e76fea0f.png";